import { Box, BoxProps, Flex } from "@chakra-ui/react";
import { ReactNode } from "react";

type Props = BoxProps & {
  children?: ReactNode;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
};

export default function TableControlsFooter({
  children,
  leftContent,
  rightContent,
  ...rest
}: Props) {
  return (
    <Box
      {...rest}
      sx={{
        ...rest.sx,
        containerType: "inline-size",
        containerName: "table-controls-footer",
        "@container table-controls-footer (max-width: 40rem)": {
          ".table-controls-footer": { flexWrap: "wrap" },
          ".table-controls-footer-center": { order: 1, flex: "1 1 100%" },
        },
      }}
    >
      <Flex className="table-controls-footer" alignItems="flex-start" gap={3}>
        <Flex
          flex="1 1 3rem"
          justifyContent="flex-start"
          alignItems="center"
          minH="1.3lh"
          mr={3}
        >
          {leftContent}
        </Flex>
        <Box className="table-controls-footer-center" flex="5 1 auto">
          {children}
        </Box>
        <Flex
          flex="1 1 3rem"
          justifyContent="flex-end"
          alignItems="center"
          minH="1.3lh"
          ml={3}
        >
          {rightContent}
        </Flex>
      </Flex>
    </Box>
  );
}
